import React from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { CheckIcon } from '@components/Icons'
import Card from '@components/Card'
import Show from '@components/Show'
import { colors } from '@lib/colors'

interface CheckItemProps {
  label: string
  isToggled: boolean
}

const ICON_SIZE = 16

export default function ({ label, isToggled }: CheckItemProps) {

  return (
    <Show when={isToggled} fallback={<></>}>
      <Card style={styles.container}>
        <Text style={styles.label}>{label}</Text>
        <View style={styles.checkbox}>
          <CheckIcon color={colors.white} size={ICON_SIZE} />
        </View>
      </Card>
    </Show>
  )
}

const styles = StyleSheet.create({
  container: {
    marginTop: 10,
    padding: 15,
    flexDirection: 'row',
  },
  label: {
    fontSize: 16,
    flex: 1,
  },
  checkbox: {
    width: 20,
    height: 20,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.green[600],
  },
})
